import Image from "next/image";
import Link from "next/link";

import RedDividerH from "../../common/RedDividerH";
import { blurDataURL } from "../../../utils/constants/images";

const ClubGroupCard = ({ clubGroupCard }) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 sm:grid-rows-2 sm:gap-x-6 lg:gap-8">
        {clubGroupCard.map((card) => {
          return (
            <div
              key={card.id}
              className="group w-full h-80 aspect-w-2 aspect-h-1 rounded-md overflow-hidden transform transition duration-500 hover:scale-105"
            >
              <div className="object-center object-cover group-hover:opacity-75 sm:absolute sm:inset-0 sm:w-full sm:h-full">
                <Image
                  src={card.imgSrc}
                  fill="true"
                  alt="Club Information Thumbnail"
                  quality={100}
                  placeholder="blur"
                  blurDataURL={blurDataURL}
                  className="object-cover sm:object-fill md:object-cover lg:object-fill"
                />
              </div>

              <div
                aria-hidden="true"
                className="w-full h-80 bg-gradient-to-b from-transparent to-black opacity-100 sm:absolute sm:inset-0"
              ></div>
              <div className="px-6 flex items-end sm:absolute sm:inset-0">
                <div>
                  <RedDividerH />

                  <h3 className="mt-2 mb-4 font-semibold text-white text-base lg:text-xl xl:text-xl 2xl:text-xl">
                    <Link href={`${card.href}`}>
                      <span className="absolute inset-0"></span>
                      {card.title}
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ClubGroupCard;
